import React from 'react';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg'
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import { useHistory, useParams } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from 'react';
import { useEffect } from 'react';
import UrCarAction from './UrCarAction';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import PageNotFound from '../FallBackUI/PageNotFound';

// import wsBaseURL from '../../Services/Constant';
// import { w3cwebsocket as W3CWebSocket } from "websocket";


// const ws=new WebSocket(wsBaseURL);
// const contentDefaultMessage = "Start writing your document here";
    
const Carlist = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [carDetail,setCarDetail]=useState([]);
    const [allcarDetail,setAllCarDetail]=useState([]);
    const [soldcarDetail,setSoldCarDetail]=useState([]);
    const successData = useSelector(state => state.LoginReducer.payload);	
	  const dealerData = useSelector(state => state.DealerReducer.payload);

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
	console.log("successData====2222==",successData)

//   useEffect(()=>{
   
//     setTimeout(()=>{
//         wsCall()
//     },3000)
    
            
// },[])

// const wsCall = () => {

//   ws.onopen = () => {
//       console.log('WebSocket ws Connected');
//   };

//   console.log('wsCall===========>', );
  
//   ws.send(JSON.stringify({seller_dealer_id:successData.seller_dealer_id,seller_id:successData.seller_id,seller_token:successData.seller_token   ,model:'allCars'}))
//   ws.send(JSON.stringify({seller_dealer_id:successData.seller_dealer_id,seller_id:successData.seller_id,seller_token:successData.seller_token  ,model:'recentlysoldcars'}))

//   ws.onmessage = (message) => {
//       console.log("check the message ===",message)
//       const dataFromServer = JSON.parse(message.data)
//       console.log("check the  data FromServer", dataFromServer)

//       switch(dataFromServer[1]) {

          
//           case "allCars":
//             getallcar (dataFromServer[0]);
              
//               break;
//           case "recentlysoldcars":
//             getsoldcar (dataFromServer[0]);
//               break;
          
//           default:
              
//       }



//   }

// }

const getallcar=(data)=>{
  let request={
    // seller_dealer_id: successData.seller_dealer_id,
    seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id :data.seller_dealer_id,

    seller_id:successData.seller_id,
    seller_token:successData.seller_token 
  }
  console.log("+++++++++==++",request)
  API.post('allCars/condition',request).then(res=>{
      console.log("all response",res.data.data);
     // const {results} = res.data.data;
      console.log(" all Response data",res.data.data);
      //if(results.length>0){
        if (res.data.success === true) {
      setAllCarDetail(res.data.data);
      console.log("all car Detail",res.data.data);
      setLoading(false);
      //}
      //setrecentCarFlag(!recentCarFlag)
    }
    else {
        setErrors(res.data.error)
        setErrorFlag(true)
    }
})
    .catch(function (error) {
        if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
        }
    });
}
const getsoldcar=(data)=>{
  let request={
    // seller_dealer_id: successData.seller_dealer_id,
    seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id :data.seller_dealer_id,

    seller_id:successData.seller_id,
    seller_token:successData.seller_token 
  }
  console.log("+++++++++==++",request)
  API.post('recentlysoldcars/condition',request).then(res=>{
      console.log("sold response",res.data.data);
     // const {results} = res.data.data;
      console.log(" sold Response data",res.data.data);
      //if(results.length>0){
        if (res.data.success === true) {
      setSoldCarDetail(res.data.data);
      console.log("sold car Detail",res.data.data);
      // setLoading(false);
      //}
      //setrecentCarFlag(!recentCarFlag)
    }
    else {
        setErrors(res.data.error)
        setErrorFlag(true)
    }
})
    .catch(function (error) {
        if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
        }
    });
}
      const allredirectpage=(pathid,seller_data)=>{
        // console.log("seller_dealer_id+++++",seller_dealer_id)
        dispatch(UrCarAction.sellerid(seller_data))
        // history.push("/cardetails/"+pathid);
        if(seller_data.status==="sold"){
          // history.push("/cardetails/"+pathid);
          history.push({
            pathname: "/soldcardetails",
            state: {backURL:"/carlist", id:pathid}
            });
        }
        history.push({
          pathname: "/cardetails",
          state: {backURL:"/allcars", id:pathid}
          });
      }
      const soldredirectpage=(pathid,seller_data,title_status_name)=>{
        // console.log("seller_dealer_id+++++",seller_dealer_id)
        dispatch(UrCarAction.sellerid(seller_data))
        // history.push("/cardetails/"+pathid);
        history.push({
          pathname: "/soldcardetails",
          state: {backURL:"/carlist", id:pathid, titlesold : title_status_name}
          });
      }
      const rerunCarPage=(pathid,seller_data)=>{
        // console.log("seller_dealer_id+++++",seller_dealer_id)
        dispatch(UrCarAction.sellerid(seller_data))
        // history.push("/reRunEditdetails/"+pathid);
        history.push({
          pathname: "/reRunEditdetails",
          state: {backURL:"/allcars", id:pathid},
          });
      }
      useEffect (()=>{
        let intervalId;
        intervalId = setInterval(() => {
          // getrecentlycar();
          getallcar(dealerData);
           getsoldcar(dealerData);
            }, 10000)
        return () => clearInterval(intervalId);
        },[])
      useEffect(() => {
        // getrecentlycar();
        // getallcar();
        // getsoldcar();
      },[]);
    return(
        <div> 
             {errorFlag === true ? <PageNotFound error={errors} /> :
        <main id="main" class="inner-page">
        {loading ? <Loading /> :
          <div id="recently-cars" class="recently-cars soldCars" >
         
         <div class="container-fluid aos-init aos-animate" >
         <div class="back-btn">
				<a class="back-btn-primary" onClick={() => history.push("/carlist")}><i class="bx bx-chevron-left"></i> Back</a>
			</div>
         <div class="section-title">
             <h2>All cars</h2> 
             {carDetail.length > 0 ? 
              <div class="multiAccept"><a href="#">Multi Accept</a> <a href="#">Accept All</a> </div>		  
        :""} </div>
         <div class="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
         {allcarDetail.length>0?allcarDetail
                         .map((item) =>
        
           <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6" onClick={()=>{item.isActive==="1"?allredirectpage(item.carid,item):rerunCarPage(item.carid,item)}}>
              {item.isActive==="1"?
             <div class="car-item ">	
                 
                 {/* <div class="soldRibbon">
                     <h4 class="ribbon">Sold Car</h4>
                 </div> */}
 
             
               <img src={item.image} class="carImg" alt="..."/>			  
               <div class="cars-content">		
               <h3><a >{item.year} {item.make} {item.model}</a></h3>
                 <div class="d-flex align-items-center mb-3">
                   <p class="details"><img src={speedometer}  alt=""/><span>{item.mileage} {item.mileage_type}</span></p>
                   {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                   <p class="details"><img src={gasolinePump} alt=""/><span>{item.fuel_type}</span></p>}
                 </div>
                 {item.status=="sold" ?
                     <div class="cars-prices">
                     <div class="prices">
                     <a class="cta-btns SellPrice" >Sold : <span>$ {item.sold_price} </span></a>
                     </div></div>:
     <>
                     { item.sales_type_id == 1 ? "" :
                   
                 <div class="cars-prices">
                 {item.max_price==""|| item.max_price==undefined || item.max_price==null?"":
               <div class="prices">
             <a class="cta-btns SellPrice" >Sell it now : <span>$ {item.max_price} </span></a>
             </div>}
           {item.high_bid==""|| item.high_bid==undefined || item.high_bid==null?"":
             <div class="prices">
               <a class="cta-btns highBid" >High Bid : <span> $ {item.high_bid}</span></a>
               </div>}

                 </div>}
                 </>}
               </div>
             </div>:
              <div class="car-item runout">	
                 <div class="runoutOverlay"></div>	
              {/* <div class="soldRibbon">
                  <h4 class="ribbon">Sold Car</h4>
              </div> */}

          
            <img src={item.image} class="carImg" alt="..."/>
            <div class="runoutContent">
             <p>Its not running now</p>
             <div class="text-center"><a class="cta-btns runit" href="">Run it</a></div>
           </div>

            <div class="cars-content">	
            
            <h3><a >{item.make} ({item.model}- {item.year} model)</a></h3>
              <div class="d-flex align-items-center mb-3">
                <p class="details"><img src={speedometer}  alt=""/><span>{item.mileage} {item.mileage_type}</span></p>
                {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                <p class="details"><img src={gasolinePump} alt=""/><span>{item.fuel_type}</span></p>}
              </div>
              
              <div class="cars-prices">
              {item.max_price==""|| item.max_price==undefined || item.max_price==null?"":
               <div class="prices">
             <a class="cta-btns SellPrice" >Sell it now : <span> $ {item.max_price} </span></a>
             </div>}
           {item.high_bid==""|| item.high_bid==undefined || item.high_bid==null?"":
             <div class="prices">
               <a class="cta-btns highBid" >High Bid : <span> $ {item.high_bid}</span></a>
               </div>}

              </div>
            </div>
          </div>}

           </div>): <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}
 
         <div class="text-center col-lg-12">
           {allcarDetail.length >4 ? 
                 <a onClick={() => history.push("/allcars")} class="more-btn loadmore">View More <i class="bx bx-chevron-right"></i></a>
           :""}          
               </div>
         </div>
     </div>
     
     </div>   }
         
        <section id="playstoreBlock" class="playstoreBlock">
                    <div class="container">
                        <div class="row content">
                        <div class="col-lg-12">
                        <img src={appstore} />
                            <img src={googleplay} />
                        </div>
                        
                        </div>
                
                    </div>
                    </section>
                </main>}
            </div>
    )
}
export default Carlist;